export default (enhancedHeroData) => {
    const { richMediaType, bodyText } = enhancedHeroData;

    const primaryData = bodyText[0];

    if (richMediaType === 'multi_header') {
        bodyText.map((content, index) => {
            if (index > 0) {
                content.image = primaryData.image;
                content.imageMd = primaryData.imageMd;
                content.imageSm = primaryData.imageSm;
                content.imageSrc = primaryData.imageSrc;
            }
        });
    }

    if (richMediaType === 'multi_image') {
        bodyText.map((content, index) => {
            if (index > 0) {
                content.header = primaryData.header;
                content.subHeader = primaryData.subHeader;
                content.internalSecondaryLinkText = primaryData.internalSecondaryLinkText;
            }
        });
    }

    const updatedEnhancedHeroData = [];

    for (let i = 0; i < bodyText.length; i++) {
        updatedEnhancedHeroData.push({
            ...enhancedHeroData,
            bodyText: enhancedHeroData.bodyText[i],

        });
    }

    return updatedEnhancedHeroData;
};
